import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutAdvertise = (bannerImgState, mainImgState, urlRef) => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("PUT", `/admin/advertise/${idx}`, {
            "banner_img": bannerImgState,
            "img_list": mainImgState,
            "url": urlRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate(-1)
                break
            case 400:
                if (fetchResult?.data?.error_code === "ad_idx") setAlert("광고 idx를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "banner_img") setAlert("배너 이미지를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "img_list") setAlert("본문 이미지를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("광고 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePutAdvertise